// Copyright (c) 2025 UXtechLab.
// Originally created by @taekie. Released under the MIT License. See LICENSE for details.
/**
 * VoronoiBubble Library
 * Main entry point - exports VoronoiBubble as default and helpers as named exports
 *
 * This module will be the public API surface for the library.
 * Consumers can import like:
 *   import VoronoiBubble from '@pxd-uxtech/voronoi-bubble';
 *   import { VoronoiBubble, nestingForVoronoi, VoronoiBubbleHelpers } from '@pxd-uxtech/voronoi-bubble';
 *   import { showVoronoiPopup, createDOMPopup } from '@pxd-uxtech/voronoi-bubble';
 */

// Main class
import VoronoiBubble from './VoronoiBubble.js';

// Helper utilities
import nestingForVoronoi from './nestingForVoronoi.js';
import VoronoiBubbleHelpers from './VoronoiBubbleHelpers.js';
import LabelAdjuster from './LabelAdjuster.js';
import PebbleRenderer from './PebbleRenderer.js';

// Popup helpers (legacy)
import {
  showVoronoiPopup as showVoronoiPopupLegacy,
  createDOMPopup,
  getPopupStyles,
  getBubbleStyles
} from './PopupHelpers.js';

// Utility popup function (primary implementation with format support and correct positioning)
import showVoronoiPopup from './utils/showVoronoiPopup.js';

// Default export - the main VoronoiBubble class
export default VoronoiBubble;

// Named exports for helper utilities
export {
  VoronoiBubble,
  nestingForVoronoi,
  VoronoiBubbleHelpers,
  LabelAdjuster,
  PebbleRenderer,
  showVoronoiPopup,        // Primary popup function (from utils) - with format support and correct positioning
  showVoronoiPopupLegacy,  // Legacy popup function (from PopupHelpers) - for Observable html`` template
  createDOMPopup,
  getPopupStyles,
  getBubbleStyles
};
